import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const CheckLog = localStorage.getItem("role")
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const [role, setRole] = useState(localStorage.getItem("role"))

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled mt-3" id="side-menu">
            <li>
              <Link to="/#">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>
            <li className="menu-title">Reports</li>
            <li>
              <Link to="/monthly-report">
                <i className="bx bx-detail"></i>
                <span>{props.t("Monthly Report")}</span>
              </Link>
            </li>

            {(CheckLog === "Admin" || CheckLog === "Sub-Admin") && (
              <>
                <li className="menu-title">Admin Control</li>
                <li>
                  <Link to="/clients">
                    <i className="bx bx-user"></i>
                    <span>{props.t("Clients")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/users">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                </li>
              </>
            )}

            {/* <li>
              <Link to="/customers">
                <i className="bx bx-user-plus"></i>
                <span>{props.t("Customers")}</span>
              </Link>
            </li>
            <li>
              <Link to="/gardeners ">
                <i className="bx bx-user-circle"></i>
                <span>{props.t("Gardeners")}</span>
              </Link>
            </li>
            <li>
              <Link to="/companies">
                <i className="bx bx-buildings"></i>
                <span>{props.t("Companies")}</span>
              </Link>
            </li> */}

            {/* <li className="menu-title">Products</li>
            <li>
              <Link to="/products">
                <i className="bx bx-buildings"></i>
                <span>{props.t("Products")}</span>
              </Link>
            </li> */}
            {role === "admin" && (
              <>
                <li>
                  <Link to="/all_requests">
                    <i className="bx bx-task"></i>
                    <span>{props.t("All Requests")}</span>
                  </Link>
                </li>
                <li className="menu-title">Setting</li>
                <li>
                  <Link to="/services_categories">
                    <i className="bx bx-notepad"></i>
                    <span>{props.t("All Services")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/users">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Users")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/controls">
                    <i className="bx bx-wrench"></i>
                    <span>{props.t("Controls")}</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
